module.exports = __webpack_public_path__ + "media/cycles-gameplay@lg-dd826892e140a014b268cab0e025aa5c.gif";